module.exports = __webpack_public_path__ + "img/sms-ready.ea450835.svg";